import {reactive} from 'vue'
import {getSurveyDefaults, translations} from "./constants.js";
import {costOfLivingService} from "./services/costofliving";
import {prefillEmptySurveyAnswers} from "./utils.js";

export const store = reactive({
    locale: null,
    numericCountryCode: null,
    translations: translations,
    question: {
        id: null,
        bindId: null,
    },
    regions: {
        levelOne: null,
        levelTwo: null,
        present: function () {
            return this.levelOne && this.levelTwo
        }
    },
    survey: {
        full: getSurveyDefaults(),
        mini: getSurveyDefaults(),
        get: function(surveyInstance) {
            if (surveyInstance === store.survey.full) {
                return store.survey.full;
            } else if (surveyInstance === store.survey.mini) {
                return store.survey.mini;
            }

        },
    },
    miniSurvey: {
        isSubmitted: false,
        questions: {},
        answers: {},
        data: {},
        getLanguage: function () {
            return this.data.locale.replace('_', '-')
        },
    },
    fullSurvey: {
        isSubmitted: false,
        questions: {},
        answers: {},
        data: {},
        getLanguage: function () {
            return this.data.locale.replace('_', '-')
        },
    },
    fetch: {
        isReady: {
            question: false,
            fullSurvey: false,
            miniSurvey: false,
            translations: false,
        },
        addQuestion: function (locale) {
            if (this.isReady.question) return;

            const colService = costOfLivingService(locale);
            colService.getQuestion().then(response => {
                store.question.id = response['question_id'];
                store.question.bindId = response['question_bind_id'];

                this.isReady.question = true;
            });
        },
        addTranslations: function (locale) {
            if (this.isReady.translations) return;

            const colService = costOfLivingService(locale);
            colService.getTranslations().then(response => {
                store.numericCountryCode = response['numeric_country_code'];
                store.translations = response['translations'];

                this.isReady.translations = true;
            });
        },
        addMiniSurvey: function (locale) {
            if (this.isReady.miniSurvey) return;

            const colService = costOfLivingService(locale);
            colService.getMiniSurvey().then(data => {
                store.survey.mini.questions = data.survey;
                store.survey.mini.data = data.data;
                    data.survey['question_groups'].forEach((group) => {
                        if (group.questions) {
                            group.questions.forEach((question) => {
                                prefillEmptySurveyAnswers(store.survey.mini.answers, question);
                            });
                        }
                    });

                this.isReady.miniSurvey = true;
            });
        },
        addFullSurvey: function (locale) {
            if (this.isReady.fullSurvey) return;

            const colService = costOfLivingService(locale);
            colService.getFullSurvey().then(data => {
                store.survey.full.questions = data.survey;
                store.survey.full.data = data.data;

                data.survey.categories.forEach((category) => {
                    category['question_groups'].forEach((questionGroup) => {
                        if (questionGroup.questions) {
                            questionGroup.questions.forEach((question) => {
                                prefillEmptySurveyAnswers(store.survey.full.answers, question);
                            });
                        }
                    })
                });

                this.isReady.fullSurvey = true;
            });
        }
    },
});


window.debugStore = store;